import { createFormHook } from "@tanstack/react-form";
import { lazy } from "react";
import { fieldContext, formContext } from "./contexts/formContext";

const SelectField = lazy(() => import("@/components/TanStack/SelectField"));
const MultiSelectField = lazy(() => import("@/components/TanStack/MultiSelectField"));
const SelectSeccionField = lazy(() => import("@/components/TanStack/SelectSeccionField"));
const TextField = lazy(() => import("@/components/TanStack/TextField"));
const NumberField = lazy(() => import("@/components/TanStack/NumberField"));
const DateField = lazy(() => import("@/components/TanStack/DateField"));
// const ChainSelectorField = lazy(
// 	() => import("@/components/TanStack/ChainSelectorField"),
// );
// const DateRangeField = lazy(
// 	() => import("@/components/TanStack/DateRangeField.tsx"),
// );
// const SubscribeButton = lazy(
// 	() => import("@/components/TanStack/SubscribeButton.tsx"),
// );

export const { useAppForm, withForm } = createFormHook({
	fieldComponents: {
		TextField,
		NumberField,
		DateField,
		SelectField,
		MultiSelectField,
		SelectSeccionField,
		// ChainSelectorField,
	},
	formComponents: {
		// SubscribeButton,
	},
	fieldContext,
	formContext,
});

export { useStore } from "@tanstack/react-form";
